<template>
    <v-form-field v-bind="$props">
        <template v-slot:append>
            <v-dialog v-if="showDialog" v-model="showDialog" width="600">
                <v-card>
                    <v-toolbar align="center" flat dense>
                        <v-spacer/>
                        <v-card-subtitle style="font-size: 16px;font-weight: bold">配置表达式</v-card-subtitle>
                        <v-spacer/>
                        <v-btn small icon>
                            <v-icon small @click="showDialog=false">mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-divider/>
                    <v-card-text class="mt-4">
                        <v-form-field remove-label v-model="expression" :label-width="70" :height="50"
                                      :field-width="500" label="表达式">
                            <template v-slot:append>
                                <v-btn @click="onExecute" class="ml-3" small color="primary" tile>测试</v-btn>
                            </template>
                        </v-form-field>
                        <v-gap height="10"/>
                        <v-simple-form title="测试文本" :min-height="300">
                            <template v-slot:toolbar>
                                <v-btn icon tile small color="rgba(0,0,0,.7)" @click="showMode='edit'">
                                    <v-icon small color="gray">mdi-square-edit-outline</v-icon>
                                </v-btn>
                                <v-btn icon small color="rgba(0,0,0,.7)" @click="showMode='json'">
                                    <v-icon small color="gray">mdi-eye</v-icon>
                                </v-btn>
                                <v-btn text small color="rgba(0,0,0,.7)" @click="showImportDialog=true">
                                    <v-icon small color="gray">mdi-download</v-icon>
                                    从执行记录导入
                                </v-btn>
                                <v-form-dialog title="执行记录导入" :width="380" :label-width="100" :field-width="180"
                                               field-exp="执行记录编号|id"
                                               v-if="showImportDialog"
                                               v-model="showImportDialog"></v-form-dialog>
                            </template>
                            <template v-slot:content>
                                <v-layout style="overflow: auto;max-height: 300px;padding-left: 5px;">
                                    <v-json-viewer expand :text="exampleText" v-if="showMode=='json'"></v-json-viewer>
                                    <v-form-textarea v-model="exampleText" :height="280" v-else class="ml-1"
                                                     remove-label
                                                     :field-width="540"></v-form-textarea>
                                </v-layout>
                            </template>
                        </v-simple-form>

                        <v-simple-form title="测试结果" :min-height="100">
                            <template v-slot:content>
                                <v-json-viewer style="margin-left: 5px;" :text="executeResult"></v-json-viewer>
                            </template>
                        </v-simple-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn tile color="primary" @click="onOk">确定</v-btn>
                        <v-btn tile outlined @click="showDialog=false">取消
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-btn small icon @click="expression=textContent;showDialog=true">
                <v-icon small>mdi-android-debug-bridge</v-icon>
            </v-btn>
            <slot name="append"></slot>
        </template>
        <template v-slot:label-prepend>
            <slot name="label-prepend"></slot>
        </template>
        <template v-slot:label-append>
            <slot name="label-append"></slot>
        </template>
        <template v-slot:label>
            <slot name="label"></slot>
        </template>
        <template v-slot:content>
            <v-textarea v-if="!readonly"
                        class="form-input__border"
                        style="line-height: 20px;"
                        :height="height"
                        flat
                        solo
                        :disabled="disable"
                        hide-details dense v-model="textContent"
                        @change="onchange"
            ></v-textarea>
        </template>
    </v-form-field>
</template>
<script>
    export default {
        name: "FormTextAreaField.vue",
        props: {
            small: {
                type: Boolean,
                default: false
            },
            xSmall: {
                type: Boolean,
                default: false
            },
            xxSmall: {
                type: Boolean,
                default: false
            },
            middle: {
                type: Boolean,
                default: false
            },
            large: {
                type: Boolean,
                default: false
            },
            xLarge: {
                type: Boolean,
                default: false
            },
            xxLarge: {
                type: Boolean,
                default: false
            },
            label: {
                type: String
            },
            disable: {
                type: Boolean,
                default: false,
            },
            readonly: {
                type: Boolean,
                default: false
            },
            value: null,
            placeholder: {type: String},
            autofocus: {
                type: Boolean,
                default: false
            },
            labelWidth: {
                type: Number
            },
            fieldWidth: {
                type: Number
            },
            hideLabel: {
                type: Boolean,
                default: false
            },
            removeLabel: {
                type: Boolean,
                default: false
            },
            height: {
                type: Number,
                default: 50
            }
        },
        data() {
            return {
                textContent: null,
                showDialog: false,
                showMode: 'json',
                exampleText: '{}',
                showImportDialog: false,
                expression: null,
                executeResult: null
            }
        },
        watch: {
            value(val) {
                this.textContent = val;
            }
        },
        created() {
            this.textContent = this.value;

        },
        methods: {
            onchange(val) {
                this.$emit('input', val);
                this.$emit('change', val);
            },
            onExecute() {
                let content = {
                    expression: this.expression,
                    content: this.exampleText
                }
                this.$request.request("EXPRESSION_EXECUTE", content).then(response => {
                    this.executeResult = response.data;
                })
            },
            onOk() {
                this.showDialog = false;
                this.$emit('input', this.expression);
            }
        }
    }
</script>